<!--
 - @author: linwen linwen@fjxhx.com.
 - @createDate: 2020-12-09 10:44.
 - @file: 树形下拉框.
 - @copyRight © 2020年 新和兴.All rights reserved.
-->
<template>
  <div class="tree-select">
    <el-form :inline="true">
      <el-form-item label="数据来源:">
        <el-select placeholder="请选择数据来源" popper-class="custom-select-style" v-model="selectValue">
          <el-option class="option-style" :label="selectLabel" :value="selectValue">
            <el-tree
              id="Tree"
              ref="tree"
              :data="treeData"
              :props="props"
              :accordion="accordion"
              :node-key="props.value"
              :default-checked-keys="defaultCheckedKeys"
              @node-click="handleNodeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'TreeSelect',
  data () {
    return {
      selectValue: '',  // 初始值
      selectLabel: '',
      defaultCheckedKeys: []
    }
  },
  props: {
    treeData: {
      type: Array,
      default: () => []
    },
    props: {
      type: Object,
      default: () => {
        return {
          label: 'treeName',
          value: 'treeId',
          children: 'childList'
        }
      }
    },
    value: { // 默认选中的数组
      type: String,
      default: ''
    },
    accordion: { // 是否自动收起
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(cur) {
      this.selectValue = cur
      this.init()
    }
  },
  methods: {
    init() {
      if (this.selectValue) {
        this.$nextTick(() => {
          this.selectLabel = this.$refs.tree.getNode(this.selectValue).data[this.props.label]
          this.$refs.tree.setCurrentKey(this.selectValue)// 设置默认选中
          this.defaultCheckedKeys.push(this.selectValue)
        })
      }
    },
    /**
     * @description: 清除选中
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-12-09 14:04
    */
    // clearHandle() {
    //   this.selectLabel = ''
    //   this.selectValue = null
    //   // this.defaultExpandedKey = []
    //   this.clearSelected()
    //   this.$emit('getValue', null)
    // },
    /**
     * @description: 节点被点击（切换选项）
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-12-09 14:13
    */
    handleNodeClick(node) {
      this.selectLabel = node[this.props.label]
      this.selectValue = node[this.props.value]
      this.$emit('getValue', this.selectValue)
      // this.defaultExpandedKey = []
    },
    /**
     * @description: 清除选中的样式
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-12-09 14:38
    */
    clearSelected() {
      let allNode = document.querySelectorAll('#Tree .el-tree-node')
      allNode.forEach(element => element.classList.remove('is-current'))
    }
  }
}
</script>

<style scoped lang="less">
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item{
  user-select: none;
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected{
  font-weight: normal;
}
ul li /deep/.el-tree .el-tree-node__content{
  height:auto;
  padding: 0 20px;
}
.el-tree-node__label{
  font-weight: normal;
}
.el-tree /deep/.is-current .el-tree-node__label{
  color: #409EFF;
  font-weight: 700;
}
.el-tree /deep/.is-current .el-tree-node__children .el-tree-node__label{
  color:#606266;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/TreeSelect.vue